export const ESignature_DESCRIPTION =
  "Quickly collect legally-binding electronic signatures on important documents. Use this to streamline the execution of contractor agreements, NDAs, or compliance forms directly within Wingspan.";
export const ESignature_EXAMPLE_USE_CASES =
  "Contractor agreements, NDAs, compliance forms.";
export const ESignature_COST = "Free (included)";

export const ESignature = {
  description: ESignature_DESCRIPTION,
  exampleUseCases: ESignature_EXAMPLE_USE_CASES,
  cost: ESignature_COST
};
